import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import type { EnhancedRouteLocation } from './types'
import { useRouteCacheStore } from '@/stores' // , useUserStore

import { STORAGE_TOKEN_KEY } from '@/stores/mutation-type'
// import { isLogin } from '@/utils/auth'
import setPageTitle from '@/utils/set-page-title'
import { useEventBus } from '@vueuse/core'

NProgress.configure({ showSpinner: true, parent: '#app' })
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_PUBLIC_PATH),
  routes,
})

// This will update routes at runtime without reloading the page
if (import.meta.hot) handleHotUpdate(router)

router.beforeEach(async (to: EnhancedRouteLocation) => {
  NProgress.start()

  const routeCacheStore = useRouteCacheStore()
  // const userStore = useUserStore()

  // Route cache
  routeCacheStore.addRoute(to)

  // Set page title
  // setPageTitle(to.name)
  setPageTitle()

  // 检查是否需要认证
  const publicRoutes = ['/', '/register', '/login', '/message', '/Saque', '/Broker'] //
  if (!publicRoutes.includes(to.path) && !localStorage.getItem(STORAGE_TOKEN_KEY)) {
    // 需要登录
    const authBus = useEventBus('require-auth')
    authBus.emit()
    return false
  }

  // if (isLogin() && !userStore.userInfo?.uid) await userStore.info()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
